//? nie uplne idealne riesenie touchClicku, ale neviem o lepsom
const hasTouch = window.matchMedia('(hover: none)').matches

if (hasTouch) {
    const callbacks = {
        start() {
            window.isTouchClick = true
        },
        end() {
            setTimeout(() => window.isTouchClick = false, 200)
        }
    }

    document.addEventListener('touchstart', callbacks.start)
    document.addEventListener('touchmove', callbacks.end)
    document.addEventListener('touchend', callbacks.end)
}
